// extracted by mini-css-extract-plugin
export default {"radioBlue":"radio-button_radioBlue__BEksB","radioRed":"radio-button_radioRed__J6y00"};